// Mock data for Bahhuddeshiya Prathmik Gram Seva Sahkari Societi Limited Jasrapur
import samiti from './samiti.png';
import fpo from './fpo.png';
import iffco from './iffco.png';
export const societyInfo = {
  name: "Bahhuddeshiya Prathmik Gram Seva Sahkari Society Limited, Jasrapur",
  location: "Jasrapur",
  tagline: "Empowering Rural Communities Through Cooperative Excellence",
  address: "Village Jasrapur, District Office Road, Jasrapur - 123456",
  phone: "+91 8005658962",
  email: "contact@jasrapurgsss.shop",
  coordinates: { lat: 26.8467, lng: 80.9462 } // Sample coordinates
};

export const heroSlides = [
  

{
    id: 1,
    image: samiti,
    title: "Bahuddeshiya prathmik Gram Seva Sahakari Samiti",
    subtitle: "Traditional And Modern Standards"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=1920&q=80",
    title: "Serving Rural Communities Since Inception",
    subtitle: "Government Approved Cooperative Society"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1920&q=80",
    title: "Quality Agricultural Products",
    subtitle: "From Farm to Your Home"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1592982537447-7440770cbfc9?w=1920&q=80",
    title: "Supporting Farmers, Nurturing Growth",
    subtitle: "Traditional Quality, Modern Standards"
  }
  ];

export const aboutUs = {
  title: "About Our Society",
  description: "Bahhuddeshiya Prathmik Gram Seva Sahkari Societi Limited, Jasrapur is a government-approved cooperative society dedicated to empowering rural communities through sustainable agricultural practices and quality products. Our mission is to bridge the gap between traditional farming wisdom and modern market needs, ensuring prosperity for farmers and quality for consumers.",
  highlights: [
    "Government Approved & Registered",
    "Supporting Local Farmers",
    "Quality Assurance Guaranteed",
    "Traditional Methods, Modern Standards"
  ],
  image: samiti
};

export const services = [
  {
    id: 1,
    title: "Agricultural Support",
    description: "Comprehensive support services for farmers including training, resources, and market access.",
    icon: "Sprout"
  },
  {
    id: 2,
    title: "Quality Products",
    description: "Authentic home-made spices and agricultural products directly from local producers.",
    icon: "Package"
  },
  {
    id: 3,
    title: "Farm Medicines",
    description: "Specialized medicines and treatments for crops and plants to ensure healthy yields.",
    icon: "Leaf"
  },
  {
    id: 4,
    title: "Community Development",
    description: "Initiatives focused on rural development, education, and sustainable practices.",
    icon: "Users"
  },
  {
    id: 5,
    title: "Fair Trade",
    description: "Ensuring fair prices for farmers and quality products for consumers.",
    icon: "Scale"
  }

];

export const productCategories = [
  {
    id: "fpo",
    title: "FPO Garam Masale",
    subtitle: "Authentic Home-Made Spices",
    description: "Traditional spice blends made with authentic recipes passed down through generations.",
    image: fpo,
    route: "/fpo-products"
  },
  {
    id: "medicine",
    title: "Plant Medicines",
    subtitle: "Farmer & Crop Care",
    description: "Specialized treatments and medicines for healthy crops and sustainable farming.",
    image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=600&q=80",
    route: "/medicine-products"
  },
  {
    id: "Crop Care",
    title: "IFFCO Products",
    subtitle: "IFFCO Natural Products",
    description: "Experience the power of sustainable farming with IFFCO Natural Fasal.",
    image: iffco,
    route: "/organic-products"
  }
];

export const fpoProducts = [
  {
    id: 1,
    name: "Premium Coriander Powder",
    description: "A perfect blend of aromatic spices including cardamom, cinnamon, cloves, and black pepper.",
    price: "₹115",
    weight: "500g",
    image: "https://images.unsplash.com/photo-1596040033229-a0b24c43f0f3?w=400&q=80",
    rating: 4.8
  },
  {
    id: 2,
    name: "Turmeric Powder",
    description: "Pure turmeric powder with high curcumin content, sourced from organic farms.",
    price: "₹145",
    weight: "500g",
    image: "https://images.unsplash.com/photo-1615485290382-441e4d049cb5?w=400&q=80",
    rating: 4.9
  },
  {
    id: 3,
    name: "Red Chilli Powder",
    description: "Vibrant red chilli powder with perfect heat and color for all your dishes.",
    price: "₹145",
    weight: "500g",
    image: "https://images.unsplash.com/photo-1583032015759-9d69ea2cd4c0?w=400&q=80",
    rating: 4.7
  },
  {
    id: 4,
    name: "Corn Daliya ",
    description: "Freshly ground Corn Daliya with authentic aroma and flavor.",
    price: "₹100",
    weight: "200g",
    image: "https://images.unsplash.com/photo-1599909533294-8cf2e8d8f86f?w=400&q=80",
    rating: 4.6
  }
];

export const medicineProducts = [
  {
    id: 1,
    name: "Bio Fertilizer",
    description: "Organic fertilizer enriched with beneficial microorganisms for soil health.",
    price: "₹450",
    weight: "1kg",
    image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=400&q=80",
    rating: 4.7
  },
  {
    id: 2,
    name: "Neem Oil Spray",
    description: "Natural pesticide for effective pest control without harmful chemicals.",
    price: "₹350",
    weight: "500ml",
    image: "https://images.unsplash.com/photo-1585749623556-c04b0680e212?w=400&q=80",
    rating: 4.8
  },
  {
    id: 3,
    name: "Plant Growth Booster",
    description: "Organic growth promoter with essential nutrients and minerals.",
    price: "₹280",
    weight: "250ml",
    image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=400&q=80",
    rating: 4.6
  },
  {
    id: 4,
    name: "Fungicide Solution",
    description: "Eco-friendly fungicide for preventing and treating plant diseases.",
    price: "₹400",
    weight: "500ml",
    image: "https://images.unsplash.com/photo-1585749623556-c04b0680e212?w=400&q=80",
    rating: 4.9
  },
  {
    id: 5,
    name: "Soil Conditioner",
    description: "Improves soil structure and water retention capacity.",
    price: "₹320",
    weight: "1kg",
    image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=400&q=80",
    rating: 4.7
  },
  {
    id: 6,
    name: "Root Strengthener",
    description: "Promotes strong root development and nutrient absorption.",
    price: "₹380",
    weight: "500ml",
    image: "https://images.unsplash.com/photo-1585749623556-c04b0680e212?w=400&q=80",
    rating: 4.8
  }
];

export const members = [
  {
    id: 1,
    name: "Shish Ram Saini",
    title: "Pacs Manager",
    bio: "Leading the society with 15+ years of experience in cooperative management.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80"
  },
  {
    id: 2,
    name: "Vikram Singh",
    title: "Pacs Manager",
    bio: "Dedicated to women empowerment and sustainable farming practices.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80"
  },
  {
    id: 3,
    name: "Ummed Saini",
    title: "Helper",
    bio: "Managing operations and farmer relations for over a decade.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80"
  },
  {
    id: 4,
    name: "Yogesh Kumar Saini",
    title: "FPO CEO",
    bio: "Ensuring financial transparency and sustainable growth.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80"
  },
  {
    id: 5,
    name: "Naveen Chandela",
    title: "FPO Manager",
    bio: "Expert in agricultural technology and modern farming methods.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80"
  },
  {
    id: 6,
    name: "Rajesh Kumar",
    title: "Packs Helper",
    bio: "Specializing in organic farming and quality assurance.",
    image: "https://images.unsplash.com/photo-1589571894960-20bbe2828d0a?w=400&q=80"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mohan Lal",
    role: "Farmer",
    rating: 5,
    comment: "The society has transformed my farming practices. Their support and quality products have increased my yield significantly."
  },
  {
    id: 2,
    name: "Kavita Sharma",
    role: "Customer",
    rating: 5,
    comment: "Best quality spices! The authentic taste reminds me of my grandmother's cooking. Highly recommended!"
  },
  {
    id: 3,
    name: "Suresh Kumar",
    role: "Farmer",
    rating: 4,
    comment: "Excellent medicines for crops. My plants are healthier and the harvest quality has improved."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Dr. Amit Shukla",
    role: "Agricultural Expert",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80"
  },
  {
    id: 2,
    name: "Neha Gupta",
    role: "Quality Manager",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80"
  },
  {
    id: 3,
    name: "Ravi Sharma",
    role: "Operations Head",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80"
  },
  {
    id: 4,
    name: "Pooja Singh",
    role: "Customer Relations",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80"
  }
];